import React from 'react';

const NoMatch = () => (
  <div>404 page</div>
);

export default NoMatch;
